export default [
  {
    path: '/tea-registros/',
    name: 'trabajaenagrovision',
    component: () => import('@/views/tea/registros_tea.vue'),
    meta: {
      pageTitle: 'Listar Registros TEA',
      breadcrumb: [
        {
          text: 'Registros TEA',
        },
        {
          text: 'Listar Registros TEA',
          active: true,
        },
      ],
      resource: 'trabajaenagrovision',
      action: 'menu',
    },
  },
  {
    path: '/tea-registros-movil/',
    name: 'trabajaenagrovisionmovil',
    component: () => import('@/views/tea/registros_tea_movil.vue'),
    meta: {
      pageTitle: 'Listar Registros TEA Movil',
      breadcrumb: [
        {
          text: 'Registros TEA Movil',
        },
        {
          text: 'Listar Registros TEA Movil',
          active: true,
        },
      ],
      resource: 'trabajaenagrovisionmovil',
      action: 'menu',
    },
  },
  {
    path: '/tea-usuarios/',
    name: 'trabajaenagrovisionusuarios',
    component: () => import('@/views/tea/usuarios_tea.vue'),
    meta: {
      pageTitle: 'Listar Usuarios TEA',
      breadcrumb: [
        {
          text: 'Usuarios TEA',
        },
        {
          text: 'Listar Usuarios TEA',
          active: true,
        },
      ],
      resource: 'trabajaenagrovisionusuarios',
      action: 'menu',
    },
  },
  {
    path: '/tea-reclutamiento/',
    name: 'trabajaenagrovisionreclutamiento',
    component: () => import('@/views/tea/reclutamiento_tea.vue'),
    meta: {
      pageTitle: 'Listar Reclutamientos TEA',
      breadcrumb: [
        {
          text: 'Reclutamientos TEA',
        },
        {
          text: 'Listar Reclutamientos TEA',
          active: true,
        },
      ],
      resource: 'trabajaenagrovisionreclutamiento',
      action: 'menu',
    },
  },
]